var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_378",
    "data-name": "Groupe 378",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.057,
    height: 28.06,
    viewBox: "0 0 28.057 28.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    width: 28.057,
    height: 28.06,
    fill: "#015c7e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_338",
    "data-name": "Groupe 338",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2826",
    "data-name": "Trac\\xE9 2826",
    d: "M28.058,7.126a8.682,8.682,0,0,1-.539,1.388,3.255,3.255,0,0,1-2.794,1.664c-1.186.046-2.375.025-3.562.01a1.09,1.09,0,0,1,.013-2.179c.9-.016,1.79-.005,2.686-.006h.38c-.338-.476-.619-.921-.947-1.328a11.571,11.571,0,0,0-6.906-4.232,11.424,11.424,0,0,0-9.274,2,11.431,11.431,0,0,0-4.67,7.169,11.43,11.43,0,0,0,2.007,9.349A11.592,11.592,0,0,0,11.6,25.619a11.381,11.381,0,0,0,3.131.23,2.709,2.709,0,0,1,.68.02,1.066,1.066,0,0,1,.853,1.116,1.092,1.092,0,0,1-1,1.025A13.768,13.768,0,0,1,6.242,25.7a13.312,13.312,0,0,1-5.792-8.19A13.667,13.667,0,0,1,5.336,3.033a13.322,13.322,0,0,1,7.3-2.968c.189-.02.379-.043.568-.065h1.7c.088.018.175.041.264.053.488.066.981.1,1.463.2A13.948,13.948,0,0,1,25.153,5.5c.233.3.447.611.712.975v-.33c0-.895-.006-1.79,0-2.685a1.041,1.041,0,0,1,.67-1.009,1,1,0,0,1,1.164.213,2.768,2.768,0,0,1,.354.572Z",
    transform: "translate(0 0)",
    fill: "#015c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2827",
    "data-name": "Trac\\xE9 2827",
    d: "M28.546,16.156c0,1.4-.008,2.8,0,4.192a1.438,1.438,0,0,1-.45,1.1q-2.063,2.045-4.11,4.106a1.132,1.132,0,0,1-1.237.359,1.084,1.084,0,0,1-.521-1.68,2.675,2.675,0,0,1,.257-.284q1.8-1.8,3.607-3.6a.784.784,0,0,0,.262-.615c-.011-2.612-.007-5.225-.006-7.837a1.124,1.124,0,0,1,.713-1.15A1.093,1.093,0,0,1,28.543,11.8c.011,1.041,0,2.083,0,3.124v1.233",
    transform: "translate(-13.425 -6.509)",
    fill: "#015c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2828",
    "data-name": "Trac\\xE9 2828",
    d: "M47.977,64.821a1.144,1.144,0,0,1-1.039-.85,1.058,1.058,0,0,1,.506-1.2c.357-.2.723-.388,1.1-.554a1.081,1.081,0,0,1,1.4.491,1.068,1.068,0,0,1-.4,1.431c-.36.213-.741.393-1.121.57a2.256,2.256,0,0,1-.447.108",
    transform: "translate(-28.6 -37.883)",
    fill: "#015c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2829",
    "data-name": "Trac\\xE9 2829",
    d: "M64.972,42.205a12.2,12.2,0,0,1,.429-1.4,1.026,1.026,0,0,1,1.284-.5,1.037,1.037,0,0,1,.726,1.148,8.707,8.707,0,0,1-.354,1.373,1.055,1.055,0,0,1-1.252.629,1.145,1.145,0,0,1-.833-1.245",
    transform: "translate(-39.618 -24.538)",
    fill: "#015c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2830",
    "data-name": "Trac\\xE9 2830",
    d: "M59.224,56.021a1.269,1.269,0,0,1-.975-.623.992.992,0,0,1,.033-1.113,9.6,9.6,0,0,1,.863-1.059,1.082,1.082,0,0,1,1.68,1.333,7.294,7.294,0,0,1-.9,1.1,2.638,2.638,0,0,1-.7.364",
    transform: "translate(-35.424 -32.267)",
    fill: "#015c7e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramIcon);
export default __webpack_public_path__ + "static/media/program-icon.89a929d54faae8ee2fe453abf76baa8b.svg";
export { ForwardRef as ReactComponent };